import { makeStyles } from "@material-ui/core";
import cn from "classnames";
import React, { useEffect } from "react";
import { SECTIONS } from "pages/flyer/builder/constants";
import { Settings, QrCode, Text, BG, Variables, AIGeneration, BrandKit } from "./components";
import NodesList from "../Aside/NodesList/components/LayersPanel";
import { show, hide } from "./consts";
import PdfImport, { usePdfImport } from "./components/PDFImport";

const Aside = ({ loading, selectedSection, isShowSidebar, setIsShowSidebar }) => {
  const classes = useStyles();

  const { initPDFifNeeded } = usePdfImport();
  useEffect(() => {
    initPDFifNeeded();
  }, [initPDFifNeeded]);

  const sections = React.useMemo(
    () => ({
      [SECTIONS.SETTINGS]: <Settings loading={loading} />,
      [SECTIONS.VARIABLES]: <Variables />,
      [SECTIONS.LAYERS]: <NodesList />,
      [SECTIONS.IMPORT_PDF]: <PdfImport />,
      [SECTIONS.AI_GENERATION]: <AIGeneration loading={loading} />,
      [SECTIONS.BRAND_KIT]: <BrandKit />,
    }),
    [loading]
  );

  const isAISection = selectedSection === SECTIONS.AI_GENERATION;
  const isBrandKitSection = selectedSection === SECTIONS.BRAND_KIT;

  // Auto-show sidebar when AI section is selected for better UX
  const shouldShowSidebar = isShowSidebar || isAISection;

  return (
    <div
      className={cn(
        classes.sidebar,
        isAISection ? classes.sidebarWide : isBrandKitSection ? classes.sidebarBrandKit : classes.sidebarNormal,
        shouldShowSidebar ? show : hide,
        "transition-[margin-left] duration-200"
      )}
    >
      {sections[selectedSection] || null}
      <div
        className={classes.flap}
        onClick={() => {
          setIsShowSidebar(!isShowSidebar);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="5"
          viewBox="0 0 10 5"
          fill="none"
          className={cn(classes.flapIcon, isShowSidebar ? "rotate-90" : "-rotate-90")}
        >
          <path
            d="M1 0.5L5 4.5L9 0.5"
            stroke="#2E3860"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default React.memo(Aside);

const useStyles = makeStyles({
  sidebar: {
    display: "flex",
    flexDirection: "column",
    background: "var(--color-surface-panel)",
    height: "100%",
    padding: 16,
    maxHeight: "calc(100vh - 60px)",
    borderLeft: "1px solid var(--color-surface-canvas)",
    position: "relative",
    transition: "width 0.3s ease-in-out",
    borderRight: "1px solid #E2E2FC",
  },
  sidebarNormal: {
    width: 216,
  },
  sidebarBrandKit: {
    width: 218, // 216 + 2px scrollbar
  },
  sidebarWide: {
    width: 562, // 2x width for AI chat
  },
  flap: {
    position: "absolute",
    top: "calc(50% - 35px)",
    right: "-18px",
    width: "18px",
    height: "70px",
    clipPath: "polygon(0 0, 100% 21.43%, 100% 78.57%, 0% 100%)",
    backgroundColor: "#E2E2FC",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderLeft: "1px solid #E2E2FC",
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      left: 0,
      clipPath: "polygon(0 0, 100% 21.43%, 100% 78.57%, 0% 100%)",
      backgroundColor: "var(--color-surface-panel)",
      // Shrink inward by 1px to reveal the border-colored background behind
      margin: "1px",
      marginLeft: 0,
    },
  },
  flapIcon: {
    marginRight: 0,
    position: "relative",
    zIndex: 1,
  },
  imageSection: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    transition: "opacity 0.2s ease-in-out, visibility 0.2s ease-in-out",
  },
  visible: {
    opacity: 1,
    visibility: "visible",
    pointerEvents: "auto",
  },
  hidden: {
    opacity: 0,
    visibility: "hidden",
    pointerEvents: "none",
  },
});
